import unMaskBorrowerName from './unMaskBorrowerData';

const transformFunctions = {
  UNMASK_BORROWER_NAME: unMaskBorrowerName,
};

export default transformFunctions;
